<script setup>
    import { ElAutocomplete, ElCollapseItem, ElInput, ElSelect, ElOption, ElSwitch, ElTree } from 'element-plus';
    import { useProductStore } from '../../stores/fpe'
    import { storeToRefs } from 'pinia';
    import WYSIWYG from '../utility/wysiwyg.vue'
    import Uploader from '../utility/media-uploader.vue'
    import { ref, computed, onMounted } from 'vue';
    import { ArrowRightBold, Search } from '@element-plus/icons-vue'
    
    const store = useProductStore();
    const { product, data_sets, strings, tags } = storeToRefs(store);
    const pro = ref(fpe?.editor_config.pro || false);

    const productCatSearch = ref('');
    const handleChange = (node, tree) => {
       product.value.categories = tree.checkedKeys;
    }
    const catLength = ref(0);
    const catSearchMinLength = parseInt(fpe?.catSearchMinLength);

    const countCategories = (items = []) => {
        return items.reduce((acc, item) => {
            const childrenCount = item.children ? countCategories(item.children) : 0;
            return acc + 1 + childrenCount;
        }, 0);
    };

    onMounted(() => {
        catLength.value = countCategories(data_sets.value.product_categories || []);
    });

    const filterNode = (value, data) => {
        if (!value) return data;
        return data
            .map((item) => {
                const match = item.label?.toLowerCase().includes(value.toLowerCase());
                if (item.children) {
                    const children = filterNode(value, item.children);
                    if (match || children.length) {
                        return { ...item, children };
                    }
                }
                return match ? item : null;
            })
            .filter(Boolean);
    };

    const filteredCategories = computed(() =>
        filterNode(productCatSearch.value, data_sets.value.product_categories || [])
    );

    const handleInputChange = (value) => {
        productCatSearch.value = value ?? '';
    };
 
    const searchTags = async(query) => {
       store.getTags(query);
    }

</script>

<template>
    
    <el-collapse-item :title="strings.section_title_general" class="fpe-section-general" name="general" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="name">
            <label>{{ strings.label_product_name }}</label>
            <ElInput v-model="product.name" placeholder="Product Title"/>
        </div>

        <div class="fpe-field-wrapper" data-field="description">
            <label>{{ strings.label_description }}</label>
            <WYSIWYG v-model="product.description" :value="product.description" class="fpe-editor" editor_id="fpe_description" />
        </div>

        <div class="fpe-field-wrapper" data-field="short-description">
            <label>{{ strings.label_short_description }}</label>
            <WYSIWYG v-model="product.short_description" :value="product.short_description" class="fpe-editor" editor_id="fpe_short_description" /> 
        </div>

        
        <div class="fpe-field-wrapper" data-field="catalog-visibility">
            <label>{{ strings.label_catalog_visibility }}</label>
            <ElSelect v-model="product.catalog_visibility">
                <el-option
                    v-for="(value) in Object.entries(data_sets.catalog_visibility)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>    
        </div>

        <div class="fpe-field-wrapper fpe-inline-switcher" data-field="featured">
            <label>{{ strings.label_is_featured }}</label>
            <ElSwitch v-model="product.featured" />    
        </div>

        <div class="fpe-field-wrapper" data-field="categories">
            <label>{{ strings.label_category }}</label>            
            <ElInput
                v-model="productCatSearch"
                placeholder="Search Categories"
                class="fpe-category-search"
                @update:modelValue="handleInputChange"
                icon= "el-icon-search"
                v-if="catLength > catSearchMinLength"
                :prefix-icon="Search"
            />
            <div class="fpe-cat-tree-wrapper"> 
                <ElTree
                    :data="filteredCategories"
                    :show-checkbox="true"
                    node-key="id"
                    :default-checked-keys="product.categories"
                    :check-strictly="true"
                    :default-expand-all="true"
                    @check="handleChange"
                    filterable
                />
            </div>
        </div>

        <div class="fpe-field-wrapper" data-field="tags">
            <label>{{ strings.label_tags }}</label>
            <ElSelect
                v-model="product.tags"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="searchTags"
            >
                <el-option 
                    v-for="(tag, index) in tags"
                    :key="index"
                    :label="tag"
                    :value="tag"
                
                />
            </ElSelect>
            </div> 

            <div v-if="pro" class="fpe-field-wrapper" data-field="image">
                <label>{{ strings.label_upload_image }}</label>
                <Uploader :multiple="false" v-model="product.image_id" label="Upload Product Image" />
            </div>  
            
            <div v-if="pro" class="fpe-field-wrapper" data-field="gallery-images">
                <label>{{ strings.label_upload_gallery_images }}</label>
                <Uploader :multiple="true" v-model="product.gallery_image_ids" label="Upload Gallery Images" />
            </div> 

            <div class="fpe-field-wrapper" v-if="product.type == 'external'" data-field="external-url" >
                <label>{{ strings.label_product_url }}</label>
                <ElInput v-model="product.product_url" />
            </div> 
             
            <div class="fpe-field-wrapper" v-if="product.type == 'external'" data-field="external-button-text">
                <label>{{ strings.label_button_text }}</label>
                <ElInput v-model="product.button_text" />
            </div>    

    </el-collapse-item>
</template>